import {DateTime} from 'luxon';
import {
  saleConfig,
  calculateStage,
  saleStages,
  saleEndForStage
} from '../config/sale';

const TEST_SALE_PARAM = '__testSale__';

const useSale = () => {
  const saleStage = calculateStage(testSaleDate() || getNow());

  const { saleStart} = saleConfig;


  return {
    isSale: !!saleStage,
    saleStage,
    saleStart,
    saleEnd: saleEndForStage(saleStage),
    code: saleConfig.code,
  }
}

function getNow() {
  return DateTime.now().setZone('America/Denver');
}

function testSaleDate() {
  if (window) {
    const params = new URLSearchParams(window.location.search);

    if (params.get(TEST_SALE_PARAM)) {
      return DateTime.fromISO(params.get(TEST_SALE_PARAM));
    }
  }

  return null;
}

export default useSale;
export { saleStages };
